import React, { Component } from 'react';
import Link from 'gatsby-link';

class BreadCrumbs extends Component {
	constructor(props) {
		super(props);
		this.breadcrumbsSize = this.props.data.map(x => x).filter(x => x.haveStaticUrl).length;
	}
	iteration = (item, idx) => {
		if(item.haveStaticUrl && idx < (this.breadcrumbsSize - 1)) {
			return (
				<li key={item.id}>
					<Link to={item.langPath} title={item.name}>{item.name}</Link>
				</li>
			)
		} else {
			return (
				<li key={idx}>
					<span>{item.name}</span>
				</li>
			)
		}
	};
	render() {
		return (
			<div className="container">
				<div className="row">
					<div className="small-12">
						<ul className="breadcrumbs clearfix">
							{ this.props.data.map(x => x).filter(x => x.haveStaticUrl).map(this.iteration) }
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

export default BreadCrumbs;



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/index.jsx